import { theme } from '../../styles/theme';
export const HeaderMainContainer = {
    paddingTop: '50px',
    height: '350px',
    backgroundColor: 'white',
    width: '100%',
    '@media screen and (max-width: 1200px)': {
        marginTop: '90px'
    }
};
export const AccountDataContainer = {
    width: '70%',
    borderBottom: '4px solid #B0BBD5',
    paddingBottom: '30px'
};
export const FlexCenter = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
export const AccountName = {
    fontWeight: 600,
    fontSize: '36px',
    maxWidth: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};
export const AccountTabs = {
    margin: '35px 0',
    width: '100%',
    '.MuiButtonBase-root': {
        '@media screen and (max-width: 495px)': {
            paddingLeft: 0,
            paddingRight: 0,
            margin: '0 8px'
        }
    },
    '.MuiTabs-indicator': {
        backgroundColor: theme.palette.common.violet,
        height: '3px',
        borderRadius: '4px'
    },
    '.MuiTabs-flexContainer': {
        justifyContent: 'center'
    }
};
export const AccountSingleTab = {
    '&.Mui-selected': {
        color: `${theme.palette.common.darkGrey2} !important`
    },
    flex: '1',
    borderBottom: `1px solid ${theme.palette.common.grey}`,
    paddingTop: '20px',
    paddingBottom: '20px',
    fontSize: '18px',
    fontWeight: 700,
    color: `${theme.palette.common.darkGrey8} !important`,
    maxWidth: '200px',
    textTransform: 'capitalize',
    '@media screen and (max-width: 495px)': {
        fontSize: '14px'
    }
};
//# sourceMappingURL=DashboardAccountsHeader.styles.js.map